import { useEffect, useState } from 'react';
import { OneTrustConsentGroupIds } from '../components/footer/OneTrust';

export function useConsentGroups() {
  const [activeCookieGroups, setActiveCookieGroups] = useState(
    getActiveGroups()
  );

  const handleConsentChanged = () => {
    setActiveCookieGroups(getActiveGroups());
  };

  const isConsentGroupActive = (cookieGroup) =>
    typeof window !== 'undefined' &&
    typeof window.OnetrustActiveGroups === 'undefined'
      ? true
      : activeCookieGroups.includes(cookieGroup);

  useEffect(() => {
    window.addEventListener('OneTrustGroupsUpdated', handleConsentChanged);

    return () => {
      window.removeEventListener('OneTrustGroupsUpdated', handleConsentChanged);
    };
  }, []);

  return {
    isFunctionalGroupActive: isConsentGroupActive('functional'),
    isNecessaryGroupActive: isConsentGroupActive('necessary'),
    isPerformanceGroupActive: isConsentGroupActive('performance'),
    isTargetingGroupActive: isConsentGroupActive('targeting'),
    isSocialMediaGroupActive: isConsentGroupActive('social_media'),
  };
}

function getActiveGroups() {
  return typeof window === 'undefined'
    ? []
    : Object.entries(OneTrustConsentGroupIds)
        .filter(([_, value]) => window?.OnetrustActiveGroups?.includes(value))
        .map(([key]) => key);
}
